import React from 'react';

import { StaticImage } from 'gatsby-plugin-image';

import * as styles from './footer.module.scss';

import EmailIcon from '-!svg-react-loader!../../assets/email.svg';
import { Link } from 'gatsby';
import PhoneIcon from '-!svg-react-loader!../../assets/phone.svg';

const Footer = () => {
  const pilartPhoneNumber = '+39 3200318685';
  const pilartEmail = 'carroroxana@gmail.com';

  const moveArtPhoneNumber = '+39 3514848091';
  const moveArtEmail = 'moveartssd@gmail.com';

  return (
    <footer>
      <div>
        <div className={styles.footerContentWrapper}>
          <div className={styles.services}>
            <h3>Social Media</h3>
            <ul>
              <li>
                <Link to="https://www.facebook.com/people/Pil-Art-ASD/61551065710690/" target="_blank">
                  Facebook (PilArt SSD)
                </Link>
              </li>
              <li>
                <Link to="https://www.instagram.com/pil_art_ssd/" target="_blank">
                  Instagram (PilArt SSD)
                </Link>
              </li>
              <li>
                <Link to="https://www.instagram.com/moveart_ssd/" target="_blank">
                  Instagram (MoveArt SSD)
                </Link>
              </li>
            </ul>
          </div>
          <div className={styles.contacts}>
            <h3>Contatti</h3>
            <ul>
              <li
                className={styles.contactsItemWrapper}
                onClick={() => {
                  navigator.clipboard.writeText(pilartPhoneNumber);
                }}
                role="presentation"
              >
                <PhoneIcon className={styles.contactsIcon} />
                <span>&nbsp;&nbsp; PILART: {pilartPhoneNumber}</span>
              </li>
              <li
                className={styles.contactsItemWrapper}
                onClick={() => {
                  navigator.clipboard.writeText(pilartEmail);
                }}
                role="presentation"
              >
                <EmailIcon className={styles.contactsIcon} />
                <span>&nbsp;&nbsp; PILART: {pilartEmail}</span>
              </li>
              <li
                className={styles.contactsItemWrapper}
                onClick={() => {
                  navigator.clipboard.writeText(moveArtPhoneNumber);
                }}
                role="presentation"
              >
                <PhoneIcon className={styles.contactsIcon} />
                <span>&nbsp;&nbsp; MoveArt: {moveArtPhoneNumber}</span>
              </li>
              <li
                className={styles.contactsItemWrapper}
                onClick={() => {
                  navigator.clipboard.writeText(moveArtEmail);
                }}
                role="presentation"
              >
                <EmailIcon className={styles.contactsIcon} />
                <span>&nbsp;&nbsp; MoveArt: {moveArtEmail}</span>
              </li>
            </ul>
          </div>
          <div className={styles.pilartDescription}>
            <h3>Enti</h3>
            <div className={styles.certificationImages}>
              <StaticImage src="../../images/asi-logo.jpg" alt="AsiLogo" style={{ width: '5em', borderRadius: '10px' }} />
              <StaticImage src="../../images/coni-logo.jpg" alt="ConiLogo" style={{ width: '10em', borderRadius: '10px' }} />
            </div>
          </div>
        </div>
        <div className={styles.copyright}>PilArt & MoveArt Copyright © 2026</div>
      </div>
    </footer>
  );
};

export default Footer;
